import './Admin-login.css';
import React, { useState, useCallback } from 'react';
import ThemeSwitch from '../../Components/themeSwitch/themeSwitch';
import OTPInputWithTimer from '../../Components/OTPInput/otpInputField';
import zxcvbn from 'zxcvbn';
import StepsNavigation from './step-navigation';
import { useToast } from '../../Utils/toastContext';
import { debounce } from 'lodash';
import CustomerLeftPanel from '../../Components/CustomerLeftPanel/customer-left-panel';
import { useNavigate, useLocation } from 'react-router-dom';
import ContactUs from '../../Pages/Contact-Us/contact-us';

const ForgotPassword = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const location = useLocation();

  const { from, isForced } = location.state || {};

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [emailVerfied, setEmailVerfied] = useState(false);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [mobileNumber, setmobileNumber] = useState('');
  const [userId, setUserId] = useState(null);
  const [jwtToken, setJwtToken] = useState('');
  const [mobileVerfied, setMobileVerfied] = useState(false);
  const [mobileCodeSend, setmobileCodeSend] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [strength, setStrength] = useState(null);
  const [strengthText, setStrengthText] = useState('');
  const [color, setColor] = useState('');
  const [confirmPassword, setconfirmPassword] = useState('');
  const [showconfirmPassword, setShowConfirmPassword] = useState(false);
  const [emailVerfiedByCode, setEmailVerfiedByCode] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const [isSupportOpen, setIsSupportOpen] = useState(false);

  const [currentStep, setCurrentStep] = useState(1);
  React.useEffect(() => {
    if (!emailVerfied) setCurrentStep(1);
    if (emailVerfied && !emailVerfiedByCode) setCurrentStep(1);

    if (!mobileCodeSend && !mobileVerfied && emailVerfiedByCode)
      setCurrentStep(2);
    if (mobileCodeSend && !mobileVerfied && emailVerfiedByCode)
      setCurrentStep(2);
    if (mobileCodeSend && mobileVerfied && emailVerfiedByCode)
      setCurrentStep(3);
  }, [emailVerfied, mobileCodeSend, mobileVerfied, emailVerfiedByCode]);
  const toggleConfirmPassword = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };
  const togglePassword = () => {
    setShowPassword((prevState) => !prevState);
  };
  const sendCodeToverify = async (email) => {
    const apiUrl = `${BASE_URL}/api/v1/auth/request-password-reset`;
    const bodyData = {
      email_address: email,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const sendMobileCodeToVerify = async (userId) => {
    const apiUrl = `${BASE_URL}/api/v1/auth/send-mfa-code`;
    const bodyData = {
      user_id: userId,
      session_id: sessionId,
      method: 'sms',
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const SendCode = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null; // Store the toast message
      try {
        const response = await sendCodeToverify(email);
        if (response.status == 200) {
          if (response.data) {
            setUserId(response.data.user_id);
            setSessionId(response.data.session_id);
            setEmailVerfied(true);
            toastMessage = {
              message: 'OTP sent successfully!',
              type: 'success',
            };
          } else {
            toastMessage = { message: response.message, type: 'success' };
          }
        } else {
          toastMessage = { message: response.message, type: 'error' };
          setEmailVerfied(false);
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
        setEmailVerfied(false);
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [email], // Dependencies
  );
  const handleSubmitMobile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postLoginSubmitted(userId, otp);
        if (response.status == 200) {
          setJwtToken(response.data.token);
          setmobileNumber(response.data.masked_phone);
          setOtp('');
          setEmailVerfiedByCode(true);
        } else {
          toastMessage = { message: response.message, type: 'error' };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [otp, userId, sessionId], // Dependencies
  );
  const handleSendMobile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const responseMobile = await sendMobileCodeToVerify(userId);
        if (responseMobile.status == 200) {
          setmobileCodeSend(true);
        } else {
          toastMessage = { message: responseMobile.message, type: 'error' };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [userId, sessionId], // Dependencies
  );
  const handleSubmitVerifyMobile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;

      try {
        const response = await verifyMobile(userId, otp);
        if (response.status == 200) {
          setMobileVerfied(true);
          setJwtToken(response.data.token);
          toastMessage = {
            message: 'Mobile Verification Successful!',
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [otp, userId, sessionId], // Dependencies
  );
  const handleChangePassword = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await changePassword(userId, password);
        if (response.status == 200) {
          navigate('/login', {
            state: {
              passwordReset: true,
            },
          });
        } else {
          toastMessage = { message: response.message, type: 'error' };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [password, userId, sessionId], // Dependencies
  );
  const verifyMobile = async (userId, otp) => {
    const headers = {
      'Content-Type': 'application/json',
    };

    if (jwtToken) {
      headers.Authorization = `Bearer ${jwtToken}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/auth/verify-reset-password-sms`;
    const bodyData = {
      code: otp,
      user_id: userId,
      session_id: sessionId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const changePassword = async (userId, password) => {
    const headers = {
      'Content-Type': 'application/json',
    };

    if (jwtToken) {
      headers.Authorization = `Bearer ${jwtToken}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/auth/reset-password`;
    const bodyData = {
      password: password,
      user_id: userId,
      session_id: sessionId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const postLoginSubmitted = async (userId, otp) => {
    const apiUrl = `${BASE_URL}/api/v1/auth/verify-reset-password-email`;
    const bodyData = {
      user_id: userId,
      code: otp,
      purpose: 'forgot_password',
      session_id: sessionId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    // Check password strength
    const result = zxcvbn(value);
    const score = result.score;

    // Set strength level
    setStrength(score);

    // Set condition text and color
    switch (score) {
      case 0:
        setStrengthText('Very Weak');
        setColor('text-red-500');
        break;
      case 1:
        setStrengthText('Weak');
        setColor('text-orange-500');
        break;
      case 2:
        setStrengthText('Moderate');
        setColor('text-yellow-500');
        break;
      case 3:
        setStrengthText('Strong');
        setColor('text-green-500');
        break;
      case 4:
        setStrengthText('Very Strong');
        setColor('text-blue-500');
        break;
      default:
        setStrengthText('');
        setColor('');
    }
  };
  const calculateStrength = (password) => {
    let score = 0;

    // Conditions
    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;

    return score;
  };

  const strengthScore = calculateStrength(password);

  return (
    <div className="flex  flex-col lg:flex-row h-screen dark:bg-[#101010] bg-[#FFFFFF]">
      <CustomerLeftPanel />
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="w-full right-div lg:w-2/5 flex flex-col">
        {/* <ThemeSwitch /> */}
        <div className="dark:bg-[#101010]  bg-[#FAFAFA] flex justify-end py-[10px] px-[15px]">
          <button
            onClick={() => setIsSupportOpen(true)}
            className={`flex items-center bg-black  h-11 gap-2 px-3 py-2 text-xs rounded-xl transition-all duration-200 text-white shadow hover:scale-105`}
            style={{ background: '' }}
          >
            {/* Icon */}
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M18 13a3 3 0 01-3 3h-1v-4h1a3 3 0 013 3zM6 13a3 3 0 003 3h1v-4H9a3 3 0 00-3 3z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 3a9 9 0 00-9 9v3a3 3 0 003 3h1v-6H6a6 6 0 1112 0h-1v6h1a3 3 0 003-3v-3a9 9 0 00-9-9z"
              />
            </svg>

            {/* Text */}
            <span className="hidden sm:inline">Need Help?</span>
          </button>
        </div>
        <StepsNavigation currentStep={currentStep} />
        {isSupportOpen && (
          <div className="fixed inset-0 z-[20] flex items-center justify-center bg-black/40 backdrop-blur-sm">
            {/* Modal */}
            <ContactUs
              onClose={() => setIsSupportOpen(false)}
              isLogin={false}
            />
          </div>
        )}
        {emailVerfied ? (
          <div>
            {!mobileCodeSend && !emailVerfiedByCode && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Please Check your email{' '}
                </h2>

                <form
                  className="w-full max-w-sm"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (otp.length < 6) {
                      showToast('Please Enter 6 digit OTP', 'error');
                      return;
                    }
                    setLoading(true);
                    handleSubmitMobile(e);
                  }}
                >
                  <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                    Please check your e-mail account for the verification code
                    we just sent you and enter that code in the box below.
                  </p>
                  <div className="mb-2">
                    <label
                      htmlFor="maskedData"
                      className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                    >
                      Code sent to:
                    </label>
                    <input
                      id="maskedData"
                      name="maskedData"
                      type="text"
                      value={email}
                      required={true}
                      disabled={true}
                      className="h-[2.813rem] rounded-lg  disabled-text dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                    />
                  </div>
                  <div className="mb-4 mt-10">
                    <OTPInputWithTimer
                      onOtpChange={(value) => setOtp(value)}
                      onLoadingChange={(value) => setLoading(value)}
                      initialTime={300}
                      userId={email}
                      postCode={SendCode}
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-[#375AE7] text-white rounded-full font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    Submit
                  </button>
                </form>
                <div className="mt-6 mb-4 max-w-sm w-full text-center">
                  <img src="/line.svg" alt="Logo" className="h-auto" />
                  <button
                    onClick={() => navigate('/login')}
                    type="submit"
                    className="w-full mt-10 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-white rounded-full text-black font-medium text-md py-3 border-2 border-black flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    <img
                      src="/arrow-left-password.svg" // Replace with the correct path to your icon image
                      alt="Icon"
                      className="w-4 h-4" // Adjust size as needed
                    />
                    Back To Log in
                  </button>
                </div>
              </div>
            )}
            {!mobileCodeSend && !mobileVerfied && emailVerfiedByCode && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Please check your mobile!{' '}
                </h2>
                <form
                  className="w-full max-w-sm"
                  onSubmit={(e) => {
                    e.preventDefault();
                    setLoading(true);
                    handleSendMobile(e);
                  }}
                >
                  <div className="mb-4">
                    <label
                      htmlFor="email"
                      className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                    >
                      Mobile
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="text"
                      value={mobileNumber}
                      required={true}
                      disabled={true}
                      className="h-[2.813rem] rounded-lg  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black disabled-text text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setmobileNumber(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-10 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-[#375AE7] text-white rounded-full font-medium text-md py-3  flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    Get a Code
                  </button>
                </form>
                <div className="mt-6 mb-4 max-w-sm w-full text-center">
                  <img src="/line.svg" alt="Logo" className="h-auto" />
                  <button
                    onClick={() => navigate('/login')}
                    type="submit"
                    className="w-full mt-10 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-white rounded-full text-black font-medium text-md py-3 border-2 border-black flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    <img
                      src="/arrow-left-password.svg" // Replace with the correct path to your icon image
                      alt="Icon"
                      className="w-4 h-4" // Adjust size as needed
                    />
                    Back To Log in
                  </button>
                </div>
              </div>
            )}
            {mobileCodeSend && !mobileVerfied && emailVerfiedByCode && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Please check your mobile!
                </h2>

                <form
                  className="w-full max-w-sm"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (otp.length < 6) {
                      showToast('Please Enter 6 digit OTP', 'error');
                      return;
                    }
                    setLoading(true);
                    handleSubmitVerifyMobile(e);
                  }}
                >
                  <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                    Please check your mobile for the verification code we just
                    sent you and enter that code in the box below.
                  </p>
                  <div className="mb-2">
                    <label
                      htmlFor="maskedData"
                      className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                    >
                      Code sent to:
                    </label>
                    <input
                      id="maskedData"
                      name="maskedData"
                      type="text"
                      value={mobileNumber}
                      required={true}
                      disabled={true}
                      className="h-[2.813rem] rounded-lg  disabled-text dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                    />
                  </div>
                  <div className="mb-4 mt-10">
                    <OTPInputWithTimer
                      onOtpChange={(value) => setOtp(value)}
                      onLoadingChange={(value) => setLoading(value)}
                      initialTime={300}
                      userId={userId}
                      postCode={SendCode}
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-[#375AE7] text-white rounded-full  font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    Submit
                  </button>
                </form>
                <div className="mt-6 mb-4 max-w-sm w-full text-center">
                  <img src="/line.svg" alt="Logo" className="h-auto" />
                  <button
                    onClick={() => navigate('/login')}
                    type="submit"
                    className="w-full mt-10 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-white rounded-full text-black font-medium text-md py-3 border-2 border-black flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    <img
                      src="/arrow-left-password.svg" // Replace with the correct path to your icon image
                      alt="Icon"
                      className="w-4 h-4" // Adjust size as needed
                    />
                    Back To Log in
                  </button>
                </div>
              </div>
            )}
            {mobileCodeSend && mobileVerfied && emailVerfiedByCode && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Create new password!
                </h2>

                <form
                  className="w-full max-w-sm"
                  onSubmit={(e) => {
                    e.preventDefault();
                    setLoading(true);
                    handleChangePassword(e);
                  }}
                >
                  <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                    This password should be different from the previous
                    password.{' '}
                  </p>
                  <div className="mb-4">
                    <div className="relative mt-1">
                      {/* Password Input Field */}
                      <label
                        htmlFor="password"
                        className="block color-test dark:text-gray-300 font-normal color-test text-md mb-1"
                      >
                        Password
                      </label>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        required={true}
                        id="password"
                        onChange={handlePasswordChange}
                        className="h-[2.813rem] rounded-lg  appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Type password"
                      />
                      <button
                        type="button"
                        onClick={togglePassword}
                        className="absolute right-3 set-top"
                      >
                        {' '}
                        {showPassword ? (
                          <img src="/eye.svg" alt="Logo" className="h-auto" />
                        ) : (
                          <img
                            src="/eye-slash.svg"
                            alt="Logo"
                            className="h-auto"
                          />
                        )}
                      </button>

                      <div className="display-none flex gap-1  absolute top-0 right-0 mt-4">
                        <div
                          className={
                            strengthScore > 0 && strengthScore < 2
                              ? 'bg-red-400 px-4 h-1 rounded-md'
                              : strengthScore >= 2 && strengthScore < 4
                                ? 'bg-yellow-400 px-4 h-1 rounded-md'
                                : strengthScore === 4
                                  ? 'bg-green-400 px-4 h-1 rounded-md'
                                  : 'bg-gray-400 px-4 h-1 rounded-md'
                          }
                        ></div>
                        <div
                          className={
                            strengthScore >= 2 && strengthScore < 4
                              ? 'bg-yellow-400 px-4 h-1 rounded-md'
                              : strengthScore === 4
                                ? 'bg-green-400 px-4 h-1 rounded-md'
                                : 'bg-gray-400 px-4 h-1 rounded-md'
                          }
                        ></div>
                        <div
                          className={
                            strengthScore >= 3 && strengthScore < 4
                              ? 'bg-yellow-400 px-4 h-1 rounded-md'
                              : strengthScore === 4
                                ? 'bg-green-400 px-4 h-1 rounded-md'
                                : 'bg-gray-400 px-4 h-1 rounded-md'
                          }
                        ></div>
                        <div
                          className={
                            strengthScore === 4
                              ? 'bg-green-400 px-4 h-1 rounded-md'
                              : 'bg-gray-400 px-4 h-1 rounded-md'
                          }
                        ></div>
                      </div>
                    </div>
                    {/* Password Validation Conditions */}
                    <div className="mt-4 text-md font-medium">
                      <ul>
                        <li
                          className={
                            password.length >= 8
                              ? 'text-black'
                              : 'text-[#BEBEBE]'
                          }
                        >
                          {password.length >= 8 ? (
                            <img
                              src="/tick-circle.svg"
                              alt="check"
                              className="w-5 h-5 inline mr-2 text-green-500"
                            />
                          ) : (
                            <img
                              src="/tick-circle-empty.svg"
                              alt="cross"
                              className="w-5 h-5 inline mr-2 text-red-500"
                            />
                          )}
                          At least 8 characters
                        </li>
                        <li
                          className={
                            /(?=.*[0-9])/.test(password)
                              ? 'text-black'
                              : 'text-[#BEBEBE]'
                          }
                        >
                          {/(?=.*[0-9])/.test(password) ? (
                            <img
                              src="/tick-circle.svg"
                              alt="check"
                              className="w-5 h-5 inline mr-2 text-green-500"
                            />
                          ) : (
                            <img
                              src="/tick-circle-empty.svg"
                              alt="cross"
                              className="w-5 h-5 inline mr-2 text-red-500"
                            />
                          )}
                          At least 1 number
                        </li>
                        <li
                          className={
                            /(?=.*[!@#$%^&*()_+={}\[\]|:;"'<>,.?/`~\\/-])/.test(
                              password,
                            )
                              ? 'text-black'
                              : 'text-[#BEBEBE]'
                          }
                        >
                          {/(?=.*[!@#$%^&*()_+={}\[\]|:;"'<>,.?/`~\\/-])/.test(
                            password,
                          ) ? (
                            <img
                              src="/tick-circle.svg"
                              alt="check"
                              className="w-5 h-5 inline mr-2 text-green-500"
                            />
                          ) : (
                            <img
                              src="/tick-circle-empty.svg"
                              alt="cross"
                              className="w-5 h-5 inline mr-2 text-red-500"
                            />
                          )}
                          At least 1 special character
                        </li>
                        <li
                          className={
                            /(?=.*[a-z])/.test(password) &&
                            /(?=.*[A-Z])/.test(password)
                              ? 'text-black'
                              : 'text-[#BEBEBE]'
                          }
                        >
                          {/(?=.*[a-z])/.test(password) &&
                          /(?=.*[A-Z])/.test(password) ? (
                            <img
                              src="/tick-circle.svg"
                              alt="check"
                              className="w-5 h-5 inline mr-2 text-green-500"
                            />
                          ) : (
                            <img
                              src="/tick-circle-empty.svg"
                              alt="cross"
                              className="w-5 h-5 inline mr-2 text-red-500"
                            />
                          )}
                          Both upper and lower case characters
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="mb-4 relative">
                    <label
                      htmlFor="confirmpassword"
                      className="block color-test dark:text-gray-300 font-normal color-test text-md mb-1"
                    >
                      Confirm Password
                    </label>
                    <input
                      type={showconfirmPassword ? 'text' : 'password'}
                      value={confirmPassword}
                      required={true}
                      id="confirmpassword"
                      onChange={(e) => setconfirmPassword(e.target.value)}
                      className={`h-[2.813rem] rounded-lg w-full py-2 px-3 text-black text-base font-medium leading-tight focus:outline-none  ${
                        confirmPassword != '' && password != confirmPassword
                          ? 'border-[#FF5050] border-2'
                          : 'border'
                      }`}
                      placeholder="Re-Type password"
                    />
                    <button
                      type="button"
                      onClick={toggleConfirmPassword}
                      className="absolute right-3 set-top"
                    >
                      {' '}
                      {showconfirmPassword ? (
                        <img src="/eye.svg" alt="Logo" className="h-auto" />
                      ) : (
                        <img
                          src="/eye-slash.svg"
                          alt="Logo"
                          className="h-auto"
                        />
                      )}
                    </button>
                    {confirmPassword != '' && password != confirmPassword && (
                      <label
                        htmlFor="confirmpassword"
                        className="flex mt-1 items-center font-normal text-xs text-[#FF5050] mb-1"
                      >
                        <img
                          src="/danger.svg"
                          alt="alert Icon"
                          className="h-4 w-4 mr-2"
                        />
                        Please make sure your passwords match.
                      </label>
                    )}
                  </div>
                  <button
                    type="submit"
                    disabled={
                      strengthScore == 4 && password == confirmPassword
                        ? false
                        : true
                    }
                    className={`w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] font-medium text-md py-3  flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300 ${
                      strengthScore == 4 && password == confirmPassword
                        ? 'bg-[#375AE7] text-white rounded-full'
                        : 'bg-[#D3D3D3] rounded-full text-[#9C9C9C]'
                    }`}
                  >
                    Reset Password
                  </button>
                </form>
                <div className="mt-6 mb-4 max-w-sm w-full text-center">
                  <img src="/line.svg" alt="Logo" className="h-auto" />
                  <button
                    onClick={() => navigate('/login')}
                    type="submit"
                    className="w-full mt-10 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-white rounded-full text-black font-medium text-md py-3 border-2 border-black flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    <img
                      src="/arrow-left-password.svg" // Replace with the correct path to your icon image
                      alt="Icon"
                      className="w-4 h-4" // Adjust size as needed
                    />
                    Back To Log in
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
            <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
              {isForced ? 'Reset Password' : 'Forgot Password'}
            </h2>
            <form
              className="w-full max-w-sm"
              onSubmit={(e) => {
                e.preventDefault();
                if (!validateEmail(email)) {
                  showToast('Please Enter a Valid email!', 'error');
                  return;
                }
                setLoading(true);
                SendCode(e);
              }}
            >
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                >
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="text"
                  value={email}
                  required={true}
                  className="h-[2.813rem] rounded-lg dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <button
                type="submit"
                className="w-full mt-10 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-[#375AE7] text-white rounded-full font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
              >
                Get a Code
              </button>
            </form>
            <div className="mt-6 mb-4 max-w-sm w-full text-center">
              <img src="/line.svg" alt="Logo" className="h-auto" />
              <button
                onClick={() => navigate('/login')}
                type="submit"
                className="w-full mt-10 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-white rounded-full text-black font-medium text-md py-3 border-2 border-black flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
              >
                <img
                  src="/arrow-left-password.svg" // Replace with the correct path to your icon image
                  alt="Icon"
                  className="w-4 h-4" // Adjust size as needed
                />
                Back To Log in
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
